module.exports = __webpack_public_path__ + "static/media/night_flight_sample_5.d2364532.jpg";